<template>
  <button
    class="button button-long"
    @click="$emit('click')"
    :disabled="disabled"
  >
    <button-loader v-if="loading" />
    <span class="font-semibold" v-else>{{ buttonText }}</span>
  </button>
</template>

<script>
export default {
  props: {
    buttonText: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>
.button {
  background-color: #fcc210;
  color: var(--primaryblue);
  border: 1px solid #fcc008;
  box-sizing: border-box;
  box-shadow: 0px 6px 10px rgba(221, 144, 9, 0.25);
  border-radius: 2px;
}
button:disabled, button[disabled]{
  opacity: 0.5;
}
</style>
